export default {
      id: "arrow_short-usage",
      viewBox: "0 0 3.39 11.95",
      url: __webpack_public_path__ + "sprite.svg#arrow_short",
      toString: function () {
        return this.url;
      }
    }